<template>
  <div class="footer">
      <van-popup
        v-model="dialogvisible"
        closeable
        position="bottom"
        @close="handleClose"
        :style="{ height: tableData.length * 10 + 5 + '%' }"
        >
    <div class="main">
      职位对比
    </div>
   <van-cell v-for="(item,index) in tableData" :key="index">
     <van-row>
        <van-col span="22">{{ index + 1 + '、' +  item.positionName }}</van-col>
        <van-col span="2"><van-icon color="#FF3229" size="1rem" name="close" @click="handleDelete(item)" /></van-col>
      </van-row>
      </van-cell>
      <van-button round type="info" v-if="tableData.length > 1" size="small" style="width:12.5rem;margin-left:5.46875rem;margin-top:1rem" @click="handleContrast">开始对比</van-button>
      </van-popup>
      <van-tabbar v-model="active">
        <van-tabbar-item style="font-size: 0.875rem" @click="tabcallleyu()"><van-icon name="chat-o" />咨询</van-tabbar-item>
        <van-tabbar-item style="background-color: #2992FF; color: #fff;font-size: 0.875rem" @click="handleShow">
          <van-icon name="search" />职位对比 <span v-if="tableData.length > 0">{{ tableData.length }}</span>
          </van-tabbar-item>
      </van-tabbar>
  </div>
</template>

<script>
import {kefucommons} from '@/utils/kefu';
export default {
  props: {
    joblist: {
      type: Array,
      default: []
    }
  },
    data() {
        return {
            dialogvisible:false,
            tableData: [],
            active: 3
        }
    },
    watch: {
      joblist() {
        this.tableData = this.joblist
      }
    },
    methods: {
      handleClose() {
        // this.$emit('update:show',false)
        this.dialogvisible = false
      },
      handleDelete(item) {
        this.tableData = this.tableData.filter(items=>{
            return items.id !== item.id
        })
        this.$emit('table-data',item.id)
      },
      handleShow() {
      this.dialogvisible = true
      },
       tabcallleyu(){
			  kefucommons.callkefu();
	   	},
      handleContrast() {
          const arr = []
          this.tableData.forEach(item => {
            arr.push(item.positionCode)
          })
        this.$router.push({
            path: "/positioncontrast",
            query: { code: arr.join(',') }
          });
      }
    }
}
</script>

<style lang="scss" scoped>
  .footer {
    .main {
      width: 100%;
      height: 2.5rem /* 80/32 */;
      text-align: center;
      line-height:2.5rem;
      font-weight: bold;
      font-size: .9375rem /* 30/32 */;
    }
  }
</style>